module.exports = __webpack_public_path__ + "static/media/logo_qr02.5f0e12f7.png";